import apiClient from "../../../utilities/apiClient";

export const addVendorType = (payload) => {
  return apiClient.post(`${apiClient.Urls.vendor_type_master}`, payload, true);
};

export const getVendorTypes = (page, per_page, search) => {
  return apiClient.get(
    `${apiClient.Urls.vendor_type_master}?page=${page}&per_page=${per_page}&search=${
      search || ""
    }`,
    "",
    true
  );
};

export const updateVendorType = (id, payload) => {
  return apiClient.put(`${apiClient.Urls.vendor_type_master}/${id}`, payload, true);
};

export const deleteVendorType = (id) => {
  return apiClient.delete(`${apiClient.Urls.vendor_type_master}/${id}`, {}, true);
};
